import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  classesInputRow: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'baseline',
    marginBottom: '.4rem',
  },

  classInput: {
    flex: '1 auto',
  },
})

export default useStyles
